module.exports = __webpack_public_path__ + "img/intent_4.ec24f71a.png";